(function ($) {

    var SELECTOR = ':input[data-toggle="display"]'

    var $body = $('body');

    var InputToggleDisplay = {};

    InputToggleDisplay.changeInputToggleDisplay = function (event) {
        var $input = $(this);

        if ($input.is('input[type="checkbox"]') || $input.is('input[type="radio"]')) {
            if (!$input.prop('checked')) {
                return;
            }
        }

        var $target = $($input.attr('data-target'));
        var value = $input.attr('data-toggle-value') ? $input.data('toggle-value') : $input.val();

        $target.toggleClass('d-none', !value);

        value ? $target.show() : $target.hide();
    }

    InputToggleDisplay.refreshInputToggleDisplay = function (event) {
        $(this).trigger('change.input-toggle-display');
    }

    $(document).ready(function () {
        $body.on('change.input-toggle-display', SELECTOR, InputToggleDisplay.changeInputToggleDisplay);
        $body.on('refresh.input-toggle-display', SELECTOR, InputToggleDisplay.refreshInputToggleDisplay);
        $body.find(SELECTOR).trigger('refresh.input-toggle-display');
    });

})(require('jquery'));
